import type { AttachmentDescriptor } from '@/features/files/types/attachment.ts'

export const EMPTY_ATTACHMENT_FILES: AttachmentDescriptor[] = []
